import localforage from 'localforage'

import Offline from './Offline'
import Api from '../core/Api'

// Les notes sont persistées à la frappe : sans file, deux réécritures complètes de
// listFibsdd peuvent se croiser et la plus ancienne écraser la plus récente (MD-929).
let fileEcritures = Promise.resolve();

function exclusif(tache) {
    let resultat = fileEcritures.then(tache, tache);
    fileEcritures = resultat.catch(() => {});
    return resultat;
}

class Fibsdd {
    static serialize(data) {
        if (!data) {
            return null;
        }
        let fi = {};

        fi.numero = data.numero;
        fi.ordreTravail = data.ordre_travail;
        // Normaliser en ID (l'API n'accepte pas les objets, et la fiche peut avoir detenteur/installation en objet en local)
        fi.detenteur = (data.detenteur && typeof data.detenteur === 'object' && data.detenteur !== null && 'id' in data.detenteur)
            ? data.detenteur.id
            : data.detenteur;
        fi.installation = (data.installation && typeof data.installation === 'object' && data.installation !== null && 'id' in data.installation)
            ? data.installation.id
            : data.installation;
        fi.detecteur = (data.detecteur !== null && data.detecteur !== 0 && data.detecteur !== '' ) ? data.detecteur : null;
        fi.chargeInitiale = data.charge_init; // ATTENTION
        fi.fluideInit = data.fluide_init; // ATTENTION
        fi.cloture = data.cloture; // ATTENTION
        fi.cloturedAt = data.cloturedAt;
        fi.multiCtrl = data.multiCtrl;
        fi.nettoyage = data.nettoyage;
        fi.ctrlFonctionnement = data.ctrlFonctionnement;

        if (data.hasOwnProperty('natures')) {
            fi.interventionAssemblage = data.natures.assemblage;
            fi.interventionMiseEnService = data.natures.miseEnService;
            fi.interventionModification = data.natures.modification;
            fi.interventionMaintenance = data.natures.maintenance;
            fi.interventionControleP = data.natures.controlePeriodique;
            fi.interventionControleNp = data.natures.controleNonPeriodique;
            fi.interventionDemantelement = data.natures.demantelement;
            fi.interventionRetrofit = data.natures.retrofit;
            fi.nouveauFluide = data.natures.newFluide;
            fi.interventionAutre = data.natures.autres;
            fi.natureIntervention = data.natures.observations;

            fi.contractuel = data.natures.contractuel;
            fi.description = data.natures.description;

            if(fi.interventionControleNp === false && fi.interventionControleP === false){
                fi.detecteur = null
            }
        }

        if (data.hasOwnProperty('ctrlEtanch')) {
            fi.noFuites = data.ctrlEtanch.no_fuites
        }

        if (data.hasOwnProperty('informations')) {
            fi.tempsDeplacement = data.informations.temps_deplacement;
            fi.tempsIntervention = data.informations.temps_intervention;
            fi.descPieces = data.informations.pieces;
            fi.observations = data.informations.observations;
            fi.photo64 = data.informations.photo64;
            fi.heureArrivee = data.informations.heure_arrivee;
            fi.heureDepart = data.informations.heure_depart;
            fi.kilometrage = data.informations.kilometrage;

            fi.techs = data.informations.techs;
            fi.namesTechniciens = data.informations.namesTechniciens;

            fi.finish = data.informations.finish;
            fi.garantie = data.informations.garantie;
            fi.needDevis = data.informations.needDevis;
            fi.fromDevis = data.informations.fromDevis;
            fi.preventif = data.informations.preventif;
            fi.correctif = data.informations.correctif;

            fi.travauxEffectues = data.informations.travauxEffectues
        }

        if (data.hasOwnProperty('infosDet')) {
            fi.nomSignataire = data.infosDet.nom_signataire;
            fi.fonctionSignataire = data.infosDet.fonction_signataire;
            fi.signatureSignataire64 = data.infosDet.signature_signataire64;
        }

        // Ajouter le callback s'il est présent (pour la synchronisation avec Gazoleen)
        if (data.hasOwnProperty('callback') && data.callback !== null && data.callback !== '') {
            fi.callback = data.callback;
        }

        return fi;
    }

    async addOfflineFibsdd(data) {
        let tempId = 'N-' + +new Date();
        let list = await this.getList();

        delete data.detenteur.installations;

        data.id = tempId;
        list.push(data);

        await localforage.setItem('listFibsdd', JSON.stringify(list));
        await Offline.saveAction({
            action: 'add',
            type: 'Fibsdd',
            id: tempId
        });

        return tempId

    }

    addOnlineFibsdd(data) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .post('/fibsdd', data)
                        .then(res => {

                            if (!res.data.hasOwnProperty('errors')) {
                                resolve(res.data)
                            } else {
                                if(res.data.errors.hasOwnProperty('installation') && res.data.errors.installation === "Cette valeur n'est pas valide.\n"){
                                    //Installation supprimé :clown:

                                    //Recréer l'installation :)
                                    Offline.saveAction({
                                        action: 'add',
                                        type: 'Installation',
                                        id: data.installation
                                    })

                                    //Bypass de la fiche
                                    //resolve(res.data)
                                }
                                let errs = {
                                    apiMsg: res.data.errors,
                                    payload: data
                                };
                                reject(errs)
                            }

                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        })
    }

    updateOnline(data, id) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .patch('/fibsdd/' + id, data)
                        .then(res => {

                            if (!res.data.hasOwnProperty('errors')) {
                                resolve(res.data)
                            } else {
                                reject(res.data.errors)
                            }
                        })
                        .catch(err => {
                            if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                resolve({id: id})
                            } else {
                                reject(err)
                            }
                        })
                })
                .catch(err => reject(err))
        })
    }

    updateFibsdd(id, data, callback) {
        return exclusif(async () => {
            let list = await this.getList();

            if (!_.includes(id, 'N-')) {
                id = parseInt(id)
            }

            let index = _.findIndex(list, ['id', id]);
            list[index] = data;

            let res = await localforage.setItem('listFibsdd', JSON.stringify(list));
            try {
                await Offline.saveAction({
                    action: 'update',
                    type: 'Fibsdd',
                    id: id
                });
            } finally {
                if (callback) {
                    callback(res)
                }
            }

            return res;
        })
    }

    async getFibsdd(id) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(res => {
                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }

                    const fi = res.find(item => item.id === id);

                    resolve(fi);
                })
                .catch(err => reject(err))
        })
    }

    static async delFibsdd(id) {
        let fiObj = new Fibsdd();
        let list = await fiObj.getList();

        if (!_.includes(id, 'N-') && !_.includes(id, 'F-')) {
            id = parseInt(id)
        }

        let indexToDelete = _.findIndex(list, ['id', id]);
        list.splice(indexToDelete, 1);

        await localforage.setItem('listFibsdd', JSON.stringify(list));
        await Offline.deleteAction(id, 'Fibsdd');

        // Supprime en cascade les opérations bouteille liées, sinon elles restent
        // orphelines dans la file offline et bloquent toute la synchro suivante
        let operations = await localforage.getItem('listOperations');
        operations = operations ? JSON.parse(operations) : [];

        let linkedOperations = _.filter(operations, ['id_fibsdd', id]);
        let remainingOperations = _.reject(operations, ['id_fibsdd', id]);

        await localforage.setItem('listOperations', JSON.stringify(remainingOperations));

        for (const operation of linkedOperations) {
            await Offline.deleteAction(operation.id, 'OperationBouteille');
        }

        if(Number.isInteger(id)){
            await Offline.saveAction({
                'action': 'delete',
                'type': 'Fibsdd',
                'id': id
            });

            return true;
        }

        return true;
    }

    async getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listFibsdd')
                .then(fibsdds => {
                    const list = fibsdds ? JSON.parse(fibsdds) : null;
                    resolve(Array.isArray(list) ? list : []);
                })
                .catch(error => reject(error))

        })
    }

    static async isInitied(id) {
        return typeof id === 'string';
    }

    // payload : { audio64 } pour un enregistrement, ou { transcript } pour ré-analyser un texte corrigé
    static voiceExtract(payload) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .post('/fibsdd/voice-extract', payload)
                        .then(res => {
                            if (!res.data.hasOwnProperty('error')) {
                                resolve(res.data)
                            } else {
                                reject(res.data.error)
                            }
                        }).catch(err => reject(err))
                }).catch(err => reject(err))
        })
    }

}

export default Fibsdd



// WEBPACK FOOTER //
// ./src/js/models/Fibsdd.js